"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Lieferadresse model module.
 * @module model/Lieferadresse
 * @version 1.0.44
 */
var Lieferadresse = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Lieferadresse</code>.
   * Eine Lieferadresse einer Filiale
   * @alias module:model/Lieferadresse
   * @param gpNummer {String} GP-Nummer der Filiale
   * @param lieferadressenNummer {String} ID der Lieferadresse
   * @param lieferadresseName1 {String} Name der Filiale in der Lieferadresse
   * @param lieferadresseName2 {String} Name der Filiale in der Lieferadresse
   * @param lieferadresseStrasse1 {String} Straße der Lieferadresse
   * @param lieferadresseStrasse2 {String} Straße der Lieferadresse
   * @param lieferadresseOrt {String} Ort der Lieferadresse
   * @param lieferadressePlz {String} PLZ der Filiale
   * @param bezeichnung {String} Name der Filiale
   */
  function Lieferadresse(gpNummer, lieferadressenNummer, lieferadresseName1, lieferadresseName2, lieferadresseStrasse1, lieferadresseStrasse2, lieferadresseOrt, lieferadressePlz, bezeichnung) {
    _classCallCheck(this, Lieferadresse);
    Lieferadresse.initialize(this, gpNummer, lieferadressenNummer, lieferadresseName1, lieferadresseName2, lieferadresseStrasse1, lieferadresseStrasse2, lieferadresseOrt, lieferadressePlz, bezeichnung);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Lieferadresse, null, [{
    key: "initialize",
    value: function initialize(obj, gpNummer, lieferadressenNummer, lieferadresseName1, lieferadresseName2, lieferadresseStrasse1, lieferadresseStrasse2, lieferadresseOrt, lieferadressePlz, bezeichnung) {
      obj['gpNummer'] = gpNummer;
      obj['lieferadressenNummer'] = lieferadressenNummer;
      obj['lieferadresseName1'] = lieferadresseName1;
      obj['lieferadresseName2'] = lieferadresseName2;
      obj['lieferadresseStrasse1'] = lieferadresseStrasse1;
      obj['lieferadresseStrasse2'] = lieferadresseStrasse2;
      obj['lieferadresseOrt'] = lieferadresseOrt;
      obj['lieferadresse_plz'] = lieferadressePlz;
      obj['bezeichnung'] = bezeichnung;
    }

    /**
     * Constructs a <code>Lieferadresse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Lieferadresse} obj Optional instance to populate.
     * @return {module:model/Lieferadresse} The populated <code>Lieferadresse</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Lieferadresse();
        if (data.hasOwnProperty('gpNummer')) {
          obj['gpNummer'] = _ApiClient.default.convertToType(data['gpNummer'], 'String');
        }
        if (data.hasOwnProperty('lieferadressenNummer')) {
          obj['lieferadressenNummer'] = _ApiClient.default.convertToType(data['lieferadressenNummer'], 'String');
        }
        if (data.hasOwnProperty('lieferadresseName1')) {
          obj['lieferadresseName1'] = _ApiClient.default.convertToType(data['lieferadresseName1'], 'String');
        }
        if (data.hasOwnProperty('lieferadresseName2')) {
          obj['lieferadresseName2'] = _ApiClient.default.convertToType(data['lieferadresseName2'], 'String');
        }
        if (data.hasOwnProperty('lieferadresseStrasse1')) {
          obj['lieferadresseStrasse1'] = _ApiClient.default.convertToType(data['lieferadresseStrasse1'], 'String');
        }
        if (data.hasOwnProperty('lieferadresseStrasse2')) {
          obj['lieferadresseStrasse2'] = _ApiClient.default.convertToType(data['lieferadresseStrasse2'], 'String');
        }
        if (data.hasOwnProperty('lieferadresseOrt')) {
          obj['lieferadresseOrt'] = _ApiClient.default.convertToType(data['lieferadresseOrt'], 'String');
        }
        if (data.hasOwnProperty('lieferadresse_plz')) {
          obj['lieferadresse_plz'] = _ApiClient.default.convertToType(data['lieferadresse_plz'], 'String');
        }
        if (data.hasOwnProperty('bezeichnung')) {
          obj['bezeichnung'] = _ApiClient.default.convertToType(data['bezeichnung'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Lieferadresse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Lieferadresse</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Lieferadresse.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['gpNummer'] && !(typeof data['gpNummer'] === 'string' || data['gpNummer'] instanceof String)) {
        throw new Error("Expected the field `gpNummer` to be a primitive type in the JSON string but got " + data['gpNummer']);
      }
      // ensure the json data is a string
      if (data['lieferadressenNummer'] && !(typeof data['lieferadressenNummer'] === 'string' || data['lieferadressenNummer'] instanceof String)) {
        throw new Error("Expected the field `lieferadressenNummer` to be a primitive type in the JSON string but got " + data['lieferadressenNummer']);
      }
      // ensure the json data is a string
      if (data['lieferadresseName1'] && !(typeof data['lieferadresseName1'] === 'string' || data['lieferadresseName1'] instanceof String)) {
        throw new Error("Expected the field `lieferadresseName1` to be a primitive type in the JSON string but got " + data['lieferadresseName1']);
      }
      // ensure the json data is a string
      if (data['lieferadresseName2'] && !(typeof data['lieferadresseName2'] === 'string' || data['lieferadresseName2'] instanceof String)) {
        throw new Error("Expected the field `lieferadresseName2` to be a primitive type in the JSON string but got " + data['lieferadresseName2']);
      }
      // ensure the json data is a string
      if (data['lieferadresseStrasse1'] && !(typeof data['lieferadresseStrasse1'] === 'string' || data['lieferadresseStrasse1'] instanceof String)) {
        throw new Error("Expected the field `lieferadresseStrasse1` to be a primitive type in the JSON string but got " + data['lieferadresseStrasse1']);
      }
      // ensure the json data is a string
      if (data['lieferadresseStrasse2'] && !(typeof data['lieferadresseStrasse2'] === 'string' || data['lieferadresseStrasse2'] instanceof String)) {
        throw new Error("Expected the field `lieferadresseStrasse2` to be a primitive type in the JSON string but got " + data['lieferadresseStrasse2']);
      }
      // ensure the json data is a string
      if (data['lieferadresseOrt'] && !(typeof data['lieferadresseOrt'] === 'string' || data['lieferadresseOrt'] instanceof String)) {
        throw new Error("Expected the field `lieferadresseOrt` to be a primitive type in the JSON string but got " + data['lieferadresseOrt']);
      }
      // ensure the json data is a string
      if (data['lieferadresse_plz'] && !(typeof data['lieferadresse_plz'] === 'string' || data['lieferadresse_plz'] instanceof String)) {
        throw new Error("Expected the field `lieferadresse_plz` to be a primitive type in the JSON string but got " + data['lieferadresse_plz']);
      }
      // ensure the json data is a string
      if (data['bezeichnung'] && !(typeof data['bezeichnung'] === 'string' || data['bezeichnung'] instanceof String)) {
        throw new Error("Expected the field `bezeichnung` to be a primitive type in the JSON string but got " + data['bezeichnung']);
      }
      return true;
    }
  }]);
}();
Lieferadresse.RequiredProperties = ["gpNummer", "lieferadressenNummer", "lieferadresseName1", "lieferadresseName2", "lieferadresseStrasse1", "lieferadresseStrasse2", "lieferadresseOrt", "lieferadresse_plz", "bezeichnung"];

/**
 * GP-Nummer der Filiale
 * @member {String} gpNummer
 */
Lieferadresse.prototype['gpNummer'] = undefined;

/**
 * ID der Lieferadresse
 * @member {String} lieferadressenNummer
 */
Lieferadresse.prototype['lieferadressenNummer'] = undefined;

/**
 * Name der Filiale in der Lieferadresse
 * @member {String} lieferadresseName1
 */
Lieferadresse.prototype['lieferadresseName1'] = undefined;

/**
 * Name der Filiale in der Lieferadresse
 * @member {String} lieferadresseName2
 */
Lieferadresse.prototype['lieferadresseName2'] = undefined;

/**
 * Straße der Lieferadresse
 * @member {String} lieferadresseStrasse1
 */
Lieferadresse.prototype['lieferadresseStrasse1'] = undefined;

/**
 * Straße der Lieferadresse
 * @member {String} lieferadresseStrasse2
 */
Lieferadresse.prototype['lieferadresseStrasse2'] = undefined;

/**
 * Ort der Lieferadresse
 * @member {String} lieferadresseOrt
 */
Lieferadresse.prototype['lieferadresseOrt'] = undefined;

/**
 * PLZ der Filiale
 * @member {String} lieferadresse_plz
 */
Lieferadresse.prototype['lieferadresse_plz'] = undefined;

/**
 * Name der Filiale
 * @member {String} bezeichnung
 */
Lieferadresse.prototype['bezeichnung'] = undefined;
var _default = exports.default = Lieferadresse;